import React, { Fragment, useEffect, useMemo } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import NProgress from 'nprogress'
import { Helmet } from 'react-helmet'
// import Loader from 'components/lpui/layout/Loader'
import PublicLayout from './Public'
import AuthLayout from './Auth'
import MainLayout from './Main'
import ExternalLinkLayout from './ExternalLink'
import { PLATFORM_NAME } from '../config/global'

const Layouts = {
  public: PublicLayout,
  auth: AuthLayout,
  main: MainLayout,
  externalLink: ExternalLinkLayout,
  clear: ({ children }) => children,
}

const mapStateToProps = ({ user }) => ({ user })
let previousPath = ''

const mapDispatchToProps = dispatch => ({
  loadCurrentAccount: () =>
    dispatch({
      type: 'user/LOAD_CURRENT_ACCOUNT',
    }),
})

// Layout Rendering
const getLayout = pathname => {
  if (pathname === '/') {
    return 'public'
  }
  if (/^\/auth(?=\/|$)/i.test(pathname)) {
    return 'auth'
  }
  if (/^\/external(?=\/|$)/i.test(pathname)) {
    return 'externalLink'
  }
  if (/^\/area-candidate(?=\/|$)/i.test(pathname)) {
    return 'clear'
  }
  return 'main'
}

const Layout = ({
  user,
  children,
  loadCurrentAccount,
  location: { pathname, search },
  type = null,
  areaId = 1,
}) => {
  // NProgress & ScrollTop Management
  const currentPath = pathname + search
  if (currentPath !== previousPath) {
    window.scrollTo(0, 0)
    NProgress.start()
  }
  setTimeout(() => {
    NProgress.done()
    previousPath = currentPath
  }, 300)

  const layoutType = useMemo(() => type || getLayout(pathname), [pathname, type])

  useEffect(() => {
    loadCurrentAccount()
  }, [layoutType, loadCurrentAccount])

  const Container = Layouts[layoutType]
  const isUserAuthorized = user.authorized
  const isUserLoading = user.loading
  const isAuthLayout = layoutType === 'auth'

  const BootstrappedLayout = () => {
    // show loader when user in check authorization process, not authorized yet and not on login pages
    if (isUserLoading && !isUserAuthorized && !isAuthLayout) {
      return null
    }
    // redirect to login page if current is not login page and user not authorized
    if (!isAuthLayout && !isUserAuthorized && layoutType !== 'externalLink') {
      // gestito da keycloak
      return null
      // return <Redirect to="/auth/login" />
    }

    if (!isAuthLayout && isUserAuthorized) {
      const defaultPaths = { 1: '/', 3: '/me/', 2: '/customer/' }
      if (areaId !== user.areaId && user.role.indexOf("ROLE_EXTERNAL") === -1) {
        // gestito da keycloak
        document.location.replace(defaultPaths[user.areaId])
        return null
      }
    }

    // in other case render previously set layout
    return <Container>{children}</Container>
  }

  return (
    <Fragment>
      <Helmet titleTemplate={`%s | ${PLATFORM_NAME}`} title="" />
      {BootstrappedLayout()}
    </Fragment>
  )
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Layout))
